/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

import Calendar from './calendar/ru_RU';
import DatePicker from './date-picker/ru_RU';
import Pagination from './pagination/ru_RU';
import TimePicker from './time-picker/ru_RU';

export default {
  locale: 'ru',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Ð¤Ð¸Ð»ÑÑÑ',
    filterConfirm: 'OK',
    filterReset: 'Ð¡Ð±ÑÐ¾ÑÐ¸ÑÑ',
    selectAll: 'ÐÑÐ±ÑÐ°ÑÑ Ð²ÑÑ',
    selectInvert: 'ÐÐ½Ð²ÐµÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð²ÑÐ±Ð¾Ñ'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'ÐÑÐ¼ÐµÐ½Ð°',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'ÐÑÐ¼ÐµÐ½Ð°'
  },
  Transfer: {
    searchPlaceholder: 'ÐÐ¾Ð¸ÑÐº',
    itemUnit: 'ÑÐ»ÐµÐ¼.',
    itemsUnit: 'ÑÐ»ÐµÐ¼.'
  },
  Upload: {
    uploading: 'ÐÐ°Ð³ÑÑÐ·ÐºÐ°...',
    removeFile: 'Ð£Ð´Ð°Ð»Ð¸ÑÑ ÑÐ°Ð¹Ð»',
    uploadError: 'ÐÑÐ¸ Ð·Ð°Ð³ÑÑÐ·ÐºÐµ Ð¿ÑÐ¾Ð¸Ð·Ð¾ÑÐ»Ð° Ð¾ÑÐ¸Ð±ÐºÐ°',
    previewFile: 'ÐÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑ ÑÐ°Ð¹Ð»Ð°'
  },
  Empty: {
    description: 'ÐÐµÑ Ð´Ð°Ð½Ð½ÑÑ'
  }
};
